<template>
    <div height="medium" width="large">
        <div class="container">
            <h2 class="heading">{{ $t('modals.patient.tab.label_two') }}</h2>
            <document-tab @toggle="toggleTab"></document-tab>

            <document-tab-content
                :physician="{
                    ViewTab: isViewTabActive,
                    UploadTabs: isUploadTabActive,
                }"
                @toggle="toggleTab"
            ></document-tab-content>
        </div>
    </div>
</template>

<script>
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import DocumentTab from 'components/forms/patient/DocumentTabs'
    import DocumentTabContent from 'components/forms/patient/DocumentTabContent'
    const TabEnum = Object.freeze({
        VIEW: 'view',
        UPLOAD: 'upload',
    })
    export default {
        mixins: [PageWithDataMixin, FormMixin, HandleRequestMixin],
        components: {
            DocumentTab,
            DocumentTabContent,
        },
        data() {
            return {
                TabEnum,
                isViewTabActive: true,
                isUploadTabActive: false,
            }
        },

        methods: {
            toggleTab(name) {
                this.isViewTabActive = false
                this.isUploadTabActive = false
                switch (name) {
                    case TabEnum.VIEW:
                        this.isViewTabActive = true
                        break
                    case TabEnum.UPLOAD:
                        this.isUploadTabActive = true
                        break
                }
            },
        },
    }
</script>
<style lang="css" scoped>
    .heading {
        font-size: 16px;
        color: oklch(0.21 0.034 264.665);
        font-weight: 500;
        margin-bottom: 14px;
    }
</style>
